import React, { useRef } from "react";

const June2025 = () => {
  return (
    <div>
      <div className="single mt-125">
        <div className="container" style={{ marginTop: "20px" }}>
          <div className="section-header">
            <h1>
              New Brunswick Makes Bold Immigration Moves to Tackle Labour
              Shortages
            </h1>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="section">
                <div className="details-image">
                  <img
                    src="/img/Newsletter/New Brunswick Makes Bold Immigration Moves to Tackle Labour Shortages.png"
                    alt="New Brunswick Makes Bold Immigration Moves to Tackle Labour Shortages"
                    style={{
                      marginTop: "30px",
                      maxHeight: "400px",
                      maxWidth: "80%",
                    }}
                  />
                </div>
                <div className="details-text">
                  <p>
                    New Brunswick is stepping up in a big way to tackle its
                    growing labour shortages. With a newly secured increase in
                    its immigration allocation from the federal government, the
                    province is positioning itself as one of Canada’s most
                    proactive regions when it comes to attracting skilled talent
                    from around the world.
                  </p>
                  <h1>A Record-High Allocation: 4,250 Permanent Resident Nominations</h1>

  <p>The federal government has now approved 4,250 permanent resident nominations for New Brunswick—an increase of 1,500 over the initial quota set earlier this year. To put this into perspective, New Brunswick’s 2025 allocation is 250 higher than British Columbia’s, signaling a significant shift in how immigration is being used as a tool for economic and social development in Atlantic Canada.</p>

  <p><strong>Key Industries That Will Benefit</strong></p>

  <p>New Brunswick is directing its immigration strategy toward industries where labour shortages are most severe. The province has identified three priority sectors:</p>

  <p><strong>1. Healthcare</strong><br/>
  An aging population and growing demand for services have placed immense pressure on New Brunswick’s healthcare system. Nurses, physicians, and other medical professionals are urgently needed. The increased immigration quota will allow the province to attract internationally trained healthcare workers and fill critical roles, ensuring quality care for residents.</p>

  <p><strong>2. Education</strong><br/>
  Schools across the province are struggling to find qualified teachers and support staff. By welcoming educators from abroad, New Brunswick aims to stabilize its education sector and provide better learning environments for students across urban and rural areas.</p>

  <p><strong>3. Construction</strong><br/>
  Infrastructure development is key to New Brunswick’s long-term economic growth. Carpenters, electricians, plumbers, and other tradespeople are in high demand to support housing and public works projects. The influx of newcomers with construction skills will keep projects moving and strengthen the province’s economic foundation.</p>

  <h1>A Humanitarian Approach: Welcoming Asylum Claimants</h1>

  <p>In addition to skilled workers, New Brunswick has agreed to receive 400 asylum claimants over the next two years as part of a coordinated national effort. The federal government will provide $14.1 million in funding through the Interim Housing Assistance Program to support this initiative.</p>

  <p>This funding will ensure temporary housing and integration services are in place to help claimants begin their new lives. The province’s leadership in this area reflects a balanced approach—addressing labour needs while remaining committed to humanitarian values.</p>

  <p><em>Federal Immigration Minister Lena Metlege Diab commented,</em><br/>
  “We’re taking a more coordinated and sustainable approach to provide temporary housing and help asylum claimants settle and start building their lives in communities across Canada.”</p>

  <h1>Industry Leaders Show Strong Support</h1>

  <p>This immigration boost is being welcomed by industry leaders and key organizations across New Brunswick. From the Agricultural Alliance of NB to major employers like Irving, many see this as a vital solution to long-standing workforce shortages.</p>

  <p><em>Louis-Philippe Gauthier, Vice-President for Atlantic Canada at the Canadian Federation of Independent Business, noted:</em><br/>
  “With 51% of small business owners in NB reporting labour shortages as their top concern, every opportunity must be seized to connect skilled workers with employers.”</p>

  <h1>Support Systems for Newcomer Success</h1>

  <p>New Brunswick’s efforts don’t end at the nomination stage. The province is deeply invested in ensuring the long-term success of newcomers:</p>

  <p>• Job Matching with Local Employers<br/>
     • Language Training & Community Integration Support<br/>
     • Assistance with Housing, Childcare, and Health Services</p>

  <p>The government is also engaging directly with asylum claimants to connect them with available jobs and help them integrate quickly into the workforce and community.</p>

  <h1>Why This Matters</h1>

  <p>For skilled immigrants and their families, New Brunswick presents a promising future—a welcoming environment, targeted job opportunities, and a strong support network. For Canadian employers, it’s a lifeline in a time of urgent labour demand.</p>

  <p>Whether you're a healthcare professional, a teacher, or a skilled tradesperson, New Brunswick is calling—and it’s ready for you.</p>

  <p><strong>Need Help Navigating Your Move to New Brunswick?</strong><br/>
  At VisaPrime Consultancy, we help skilled workers, families, and employers across Canada connect through immigration. Whether you're looking to move to NB or hire talent for your growing business, our team is here to guide you—every step of the way.<br/>
  📞 Contact us today to start your immigration journey to New Brunswick.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default June2025;
